import "./About.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheExpertBehindTheStrategy from "./sections/TheExpertBehindTheStrategy";
import ProfessionalMilestones from "./sections/ProfessionalMilestones";
import Certifications from "./sections/Certifications";
import FooterInformation from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <MainNavigation />
      <TheExpertBehindTheStrategy />
      <ProfessionalMilestones />
      <Certifications />
      <FooterInformation />
    </div>;
}